import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ApiService } from '../../../core/services/api.service';
import { Vehicle } from '../../../Models/vehicle';

@Component({
    selector: 'dialog-start-iterate',
    templateUrl: './dialog-start-iterate.component.html',
    styleUrls: ['./dialog-start-iterate.component.scss']
})

export class DialogStartIterateComponent {

  vehicles: Vehicle[] = [];
  selectedVehicle: Vehicle;

  constructor(private dialogRef: MatDialogRef<DialogStartIterateComponent>, private apiService: ApiService) {
    this.getVehicles();
  }

  startIterate() {
    this.dialogRef.close(this.selectedVehicle);
  }

  getVehicles() {
    this.apiService.get('api/vehicle/findAll').subscribe((response: any) => {
      if (response.data) {
        this.vehicles = response.data;
        if (this.vehicles.length > 0)
          this.selectedVehicle = this.vehicles[0];
      }
    });
  }
}
